// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import JsonExcel from 'vue-json-excel'
import Vuex from 'vuex'


import 'froala-editor/js/plugins.pkgd.min.js';
//Import third party plugins
import 'froala-editor/js/third_party/embedly.min';
import 'froala-editor/js/third_party/font_awesome.min';
import 'froala-editor/js/third_party/spell_checker.min';
import 'froala-editor/js/third_party/image_tui.min';
// Import Froala Editor css files.
import 'froala-editor/css/froala_editor.pkgd.min.css';

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)
Vue.config.productionTip = false
 

// todo
// cssVars()
Vue.use(Vuex)

Vue.use(BootstrapVue)
Vue.component('downloadExcel', JsonExcel)
window.axios = require('axios')
// Vue.use(axios) - Commented out because axios is not a Vue plugin and Vue.use(axios) crashes Vue 2.
// axios.defaults.baseURL = 'http://localhost:3000'
// axios.defaults.imageURL = 'http://localhost:3000/u/'

// window.baseURL = 'http://localhost:3000/'
// window.imageURL = 'http://localhost:3000/u/'

axios.defaults.baseURL = 'https://tsa-api.leopardtechlabs.in/'
axios.defaults.imageURL = 'https://tsa-api.leopardtechlabs.in/u/'

window.baseURL = 'https://tsa-api.leopardtechlabs.in/'
window.imageURL = 'https://tsa-api.leopardtechlabs.in/u/'

Vue.mixin({
  data() {
    return {
      baseURL: window.baseURL,
      imageURL: window.imageURL
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  }
})
